import { render, staticRenderFns } from "./AcessarPenalidadesPedidoDocumentos.vue?vue&type=template&id=2a668c9e&scoped=true"
import script from "./AcessarPenalidadesPedidoDocumentos.vue?vue&type=script&lang=js"
export * from "./AcessarPenalidadesPedidoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./AcessarPenalidadesPedidoDocumentos.vue?vue&type=style&index=0&id=2a668c9e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a668c9e",
  null
  
)

export default component.exports